import { store } from '@/app/app-store';
import { refsService as refs } from '@/app/shared/refs.service';
import { env } from '@/environments';
import Router, { Route } from 'vue-router';
import { ProfileModel } from '@/app/shared/models';

export const userMiddleware = (router: Router) => {
  router.beforeEach(async (to: Route, from: Route, next: Function) => {
    if (
      !to.meta.isPublic &&
      !to.meta.isOidcCallback &&
      store.getters[`${env.oidcModule}/oidcIsAuthenticated`] &&
      store.getters[`${env.oidcModule}/oidcAccessToken`]
    ) {
      await refs.modules.user.loadUserInfo();
      await refs.modules.user.loadUserById(refs.modules.user.userInfo.userId);
      const profiles: ProfileModel[] = [];
      const userProfiles = refs.modules.user.userDetail.Profiles;
      if (userProfiles && userProfiles.length > 0) {
        userProfiles.map((userRole: ProfileModel) => {
          if (
            !profiles.some(
              (p) => userRole.AccountId == p.AccountId && userRole.Id == p.Id
            )
          ) {
            profiles.push({
              Id: userRole.Id,
              AccountId: userRole.AccountId,
              ApplicationId: userRole.ApplicationId,
              Name: userRole.Name,
            });
          }
        });
      }
      await refs.modules.user.loadProfiles(profiles);
    }
    next();
  });
};
